<template>
  <b-button-group>
    <template v-for="(item, i) in state">
      <b-button
        :style="item.style"
        v-if="item.count"
        :key="i"
        :size="size"
        class="p-1"
        variant="light"
        @click="onClick(item)"
      >
        <b-icon
          :icon="getIconName(item)"
          :variant="getVariant(item)"
        />
        {{ item.text }} {{ getCountText(item) }}
      </b-button>
    </template>
    <b-button
      v-if="dirty"
      variant="light"
      @click="onReset()"
      title="Reset filters"
      v-b-tooltip
    >
      <v-icon>mdi-filter-remove-outline</v-icon>
    </b-button>
  </b-button-group>
</template>

<script>
import { cloneDeep } from 'lodash-es'

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },

  data() {
    return {
      state: [],
      initialState: [],
    }
  },

  computed: {
    dirty() {
      return !this.state.every((v, i) => v.state === this.initialState[i].state)
    },
  },

  watch: {
    value: {
      handler: function () {
        this.state = cloneDeep(this.value)
        this.initialState = cloneDeep(this.state)
      },
      deep: true,
    },
  },

  methods: {
    getCountText(item) {
      if (!item.count) return null
      else return `(${item.count})`
    },
    getIconName(item) {
      if (item.state === true) return 'check-circle'
      if (item.state === false) return 'circle'
    },
    getVariant(item) {
      if (item.state === true) return 'outline-success'
      if (item.state === false) return 'outline-danger'
    },
    onClick(item) {
      item.state = !item.state
      this.$emit('input', this.state)
    },
    onReset() {
      this.state = cloneDeep(this.initialState)
      this.$emit('input', this.state)
    },
  },

  mounted() {
    this.state = cloneDeep(this.value)
    this.initialState = cloneDeep(this.state)
  },
}
</script>
